@if (formControl()) {
<div class="formula form-group">
    <mat-form-field class="form-field">
        <mat-label>{{meta()?.name}}</mat-label>
        <input matInput [readonly]="readonly() || meta()?.readonly" [placeholder]="$safeNavigationMigration(meta()?.name)"
            [formControl]="$any(formArray()?.at(arrayIndex() ?? 0) || formControl())">
        <button matSuffix mat-icon-button aria-label="Update" (click)="onFormula()">
            <mat-icon>play_circle</mat-icon>
        </button>
        @if (formControl()?.value && !meta()?.readonly && !readonly()) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
            <mat-icon>close</mat-icon>
        </button>
        }
        @if (meta()?.info) {
        <mat-hint><strong>{{meta()?.info}}</strong></mat-hint>
        }
        @if (formControl()?.hasError('script')) {
        <mat-error>
            The formula script has errors.
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
